import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { PageHeaderComponent } from '../../../../shared/components/page-header/page-header.component';
import { SkeletonLoaderComponent } from '../../../../shared/components/skeleton/skeleton.component';
import {
  CUSTOMERS_FILTER,
  PAYMENT_STATUS_OPTION,
} from '../../../../shared/constants/customers.constants';
import { PaymentStatus } from '../../../../shared/enums/enums';
import { CustomerFilter } from '../../../../shared/interface/interface';
import { CustomerModel } from '../../../../shared/models/customers.model';
import { CustomersService } from '../../../../shared/services/customers.service';
import { SharedModule } from '../../../../shared/shared.module';
import { MultiselectDropdownComponent } from '../../../../shared/components/multiselect-dropdown/multiselect-dropdown.component';

@Component({
  selector: 'app-customers',
  standalone: true,
  imports: [SkeletonLoaderComponent, PageHeaderComponent, SharedModule, MultiselectDropdownComponent],
  templateUrl: './customers.component.html',
  styleUrl: './customers.component.scss',
})
export class CustomersComponent implements OnInit, OnDestroy {
  private readonly customersFilterSubject$: BehaviorSubject<CustomerFilter> =
    new BehaviorSubject<CustomerFilter>(CUSTOMERS_FILTER);
  customersFilter = this.customersFilterSubject$.asObservable();
  customers: CustomerModel[] = [];
  isLoading: boolean = false;
  customersCount: number = 0;
  customerFilterForm = this.fb.group({
    startDate: [''],
    endDate: [''],
    paymentStatus: [PaymentStatus.ALL],
  });
  subscription = new Subscription();
  payemntStatusOption = PAYMENT_STATUS_OPTION;
  constructor(
    private readonly customerService: CustomersService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.subscribeToFilter();
    this.subscribeToFormValueChanges();
  }

  getCustomers(filter: CustomerFilter) {
    this.isLoading = true;
    this.customerService.fetchCustomers(filter).subscribe({
      next: (data) => {
        this.isLoading = false;
        this.customers =
          filter.pageNumber > 1
            ? [...this.customers, ...(data?.data?.contracts ?? [])]
            : data?.data?.contracts ?? [];
        this.customersCount = data?.data?.total ?? 0;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  subscribeToFilter() {
    this.customersFilterSubject$.subscribe((value) => {
      this.getCustomers(value);
    });
  }
  handleSearch(searchText: string) {
    if (searchText.length === 0 || searchText?.trim()) {
      this.updateCustomerFilter({
        ...this.customersFilterSubject$.value,
        pageNumber: 1,
        searchText: searchText,
      });
    }
  }
  updateCustomerFilter(filter: CustomerFilter) {
    this.customersFilterSubject$.next(filter);
  }
  loadMoreIfLastIndex() {
    const { searchText, pageNumber, limit, startDate, endDate, paymentStatus } =
      this.customersFilterSubject$.value;
    if (pageNumber * limit < this.customersCount) {
      this.updateCustomerFilter({
        searchText,
        limit,
        startDate,
        endDate,
        pageNumber: pageNumber + 1,
        paymentStatus,
      });
    }
  }
  subscribeToFormValueChanges() {
    this.customerFilterForm.valueChanges.subscribe((data) => {
      this.updateCustomerFilter({
        ...this.customersFilterSubject$.value,
        pageNumber: 1,
        startDate: data?.startDate ?? '',
        endDate: data?.endDate ?? '',
        paymentStatus: data?.paymentStatus ?? PaymentStatus.ALL,
      });
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
